
interface V3IconBinProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconBin = ({ stroke = "#D60024" }: V3IconBinProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4h12M3 4l.714 9.429c0 .416.15.816.419 1.11.268.295.631.461 1.01.461h5.714c.379 0 .742-.166 1.01-.46.268-.295.419-.695.419-1.111L13 4M6 4V1.75a.8.8 0 0 1 .195-.53.631.631 0 0 1 .472-.22h2.666c.177 0 .347.079.472.22a.8.8 0 0 1 .195.53V4" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
